<template>
  <div>
    <b-row>
      <b-col
        cols="12"
      >
        <!-- Table Container Card -->
        <b-card
          no-body
          class="mb-0"
        >
          <div class="mx-2 mb-2 mt-0">
            <b-row class="justify-content-end">
              <b-col
                cols="12"
                md="4"
                lg="2"
              >
                <label for="begin-date">Início em</label>
                <b-form-datepicker
                  id="begin-date"
                  v-model="beginDate"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  locale="pt-BR"
                  label-help=""
                />
              </b-col>
              <b-col
                cols="12"
                md="4"
                lg="2"
              >
                <label for="end-date">Fim em</label>
                <b-form-datepicker
                  id="end-date"
                  v-model="endDate"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  locale="pt-BR"
                  label-help=""
                />
              </b-col>
              <b-col
                cols="12"
                md="12"
                lg="8"
              >
                <b-row>
                  <b-col
                    cols="12"
                    md="5"
                  >
                    <label for="institution-id">Instituição</label>
                    <v-select
                      id="institution-id"
                      v-model="institutionId"
                      name="institution-id"
                      :options="institutionOptions"
                      label="label"
                      item-value="value"
                      item-text="label"
                    >
                      <span slot="no-options">Nenhuma instituição encontrada.</span>
                    </v-select>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-table
            ref="refUserListTable"
            class="position-relative table-physician"
            :items="fetchPhysicians"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="Nenhum registro correspondente encontrado"
            :sort-desc.sync="isSortDirDesc"
          >
            <template #cell(status)="{ item, index }">
              <div class="d-flex align-content-start">
                <b-tooltip
                  title="Importado com sucesso"
                  :target="`status-processed-${index}`"
                />
                <b-badge
                  v-if="item.status === 'processed' && item.metrics.errors == 0"
                  :id="`status-processed-${index}`"
                  pill
                  variant="light-success"
                >
                  Importado
                </b-badge>
                <div
                  v-else
                  class="d-flex flex-column align-items-center justify-content-center"
                >
                  <div>
                    <b-tooltip
                      title="Em processamento aguarde"
                      :target="`status-processing-${index}`"
                    />
                    <b-badge
                      v-if="item.status === 'processing'"
                      :id="`status-processing-${index}`"
                      class="progress-bar"
                      pill
                      variant="light-secondary"
                    >
                      Processando
                    </b-badge>
                  </div>
                  <div>
                    <b-tooltip
                      title="Importado parcialmente com falha"
                      :target="`status-errors-${index}`"
                    />
                    <b-badge
                      v-if="item.status === 'processed'"
                      :id="`status-errors-${index}`"
                      pill
                      variant="light-danger"
                    >
                      Com Falha
                    </b-badge>
                  </div>
                  <div
                    v-if="item.metrics"
                    class="d-inline-block text-muted font-weight-bold"
                  >
                    <span>{{ item.metrics.imports }}</span>/<span class="font-weight-bold">{{ item.metrics.errors + item.metrics.imports }}</span> importados
                  </div>
                </div>
              </div>
            </template>
            <template #cell(actions)="data">
              <b-dropdown
                variant="link"
                no-caret
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item
                  :to="{
                    name: 'import-physician-duty-view',
                    params: { id: data.item.id },
                  }"
                >
                  <feather-icon icon="FileTextIcon" />
                  <span class="align-middle ml-50">Detalhes</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="
                  d-flex
                  align-items-center
                  justify-content-center justify-content-sm-start
                "
              >
                <span class="text-muted">
                  Exibindo {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} entradas
                </span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="
                  d-flex
                  align-items-center
                  justify-content-center justify-content-sm-end
                "
              >
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalUsers"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  VBModal,
  BBadge,
  BFormDatepicker,
} from 'bootstrap-vue'
import store from '@/store'
import { onUnmounted, ref, watch } from '@vue/composition-api'
import { maskCnpj } from '@core/utils/utils'
import vSelect from 'vue-select'
import usePhysicianDutyList from './usePhysicianDutyList'
import physicianStoreModule from '../physicianDutyStoreModule'

export default {
  components: {
    BFormDatepicker,
    vSelect,
    BBadge,
    BCard,
    BRow,
    BCol,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
  },
  directives: {
    'b-modal': VBModal,
  },
  setup() {
    const MODULE_NAME = 'app-physician'

    // Register module
    if (!store.hasModule(MODULE_NAME)) { store.registerModule(MODULE_NAME, physicianStoreModule) }

    const file = ref(undefined)
    const loading = ref(false)

    watch(file, () => {
      // validateFile(file.value)
    }, { deep: true })

    const {
      fetchPhysicians,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      beginDate,
      endDate,
      institutionId,
      institutionOptions,
      onUnmountedList,
    } = usePhysicianDutyList()

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) { store.unregisterModule(MODULE_NAME) }
      onUnmountedList()
    })

    store.dispatch('app-physician/fetchInstitutions', { perPage: 99999999 })
      .then(response => {
        institutionOptions.value = response.data.data.map(inst => ({
          value: inst.id,
          label: `${inst.name} | ${maskCnpj(inst.cnpj)}`,
        }))
      })

    return {
      fetchPhysicians,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      // UI
      file,
      loading,
      beginDate,
      endDate,
      institutionId,
      institutionOptions,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.table-physician {
  min-height: 200px;
}

.progress-bar{
  max-width: 100px;
  background: rgb(178, 175, 165);
  -webkit-animation-name: pulse; /* Chrome, Safari, Opera */
  -webkit-animation-duration: 2s; /* Chrome, Safari, Opera */
  -webkit-animation-iteration-count: infinite;
  animation-name: pulse;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

@-webkit-keyframes pulse {
  0%   {background: rgb(205, 205, 204);}
  25%   {background: rgb(205, 205, 204);}
  50%   {background: rgb(205, 205, 204);}
  75%  {background: rgb(233, 233, 232);}
  85%{background: rgb(205, 205, 204);}
  100% {background: rgb(205, 205, 204);}
}

@keyframes pulse {
  0%   {background: rgb(205, 205, 204);}
  25%   {background: rgb(205, 205, 204);}
  50%   {background: rgb(205, 205, 204);}
  75%  {background: rgb(233, 233, 232);}
  85%{background: rgb(205, 205, 204);}
  100% {background: rgb(205, 205, 204);}
}

.badge.badge-light-secondary {
  color: #82868b !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
